import React, { useCallback } from 'react'
import { RootState } from 'app/rootReducer';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { addRooms } from './houseSlice';
import { changeCurrentRoom } from './houseSlice';
import { useHistory } from 'react-router-dom';
import logo from '../../app/logo.jpg';

export default function RoomInfo(): JSX.Element{
    let house = useSelector(
        (state: RootState) => state.house
    )
    let room: {[key: string]: any} = house.rooms[house.currentRoom]
    const dispatch = useDispatch();
    console.log(room)
    let rgbAmount = new Array(parseInt(room["rgb"]["amount"])).fill("")
    console.log(rgbAmount)
    rgbAmount = populateArr(rgbAmount, "rgb")

    let lightAmount = new Array(parseInt(room["light"]["amount"])).fill({navn: "", type: {dali: true, dim: false, rele: false}, elements: 0});
    let workaround = populateLight();
    console.log(workaround)

    let heatAmount = new Array(parseInt(room["heat"]["amount"])).fill("")
    heatAmount = populateArr(heatAmount, "heat")

    let coolAmount = new Array(parseInt(room["cooling"]["amount"])).fill("")
    coolAmount = populateArr(coolAmount, "cooling")

    let sunAmount = new Array(parseInt(room["sun"]["amount"])).fill("")
    sunAmount = populateArr(sunAmount, "sun")

    const history = useHistory();
    const Callback = useCallback((val) => history.push(val), [history]);

    function changeLight(event: any, lightIndex: number, typeChange: string){
        let newSelected = typeChange === "type" ? {
            dali: event.target.value === "dali" ? true : false,
            dim: event.target.value === "dim" ? true : false,
            rele: event.target.value === "rele" ? true : false,
        } : workaround[lightIndex]["type"]
        console.log(workaround)
        let updatedLight = workaround.map((list, i) => {
            console.log(list)
            if (i !== lightIndex) return list;
            if(typeChange === "type") return {
                ...list, type: newSelected
            }
            if(typeChange === "navn") return{
                ...list, navn: event.target.value
            }
            if(typeChange === "amount") return {
                ...list, elements: parseInt(event.target.value)
            }
        })
        console.log(updatedLight)
        workaround = updatedLight
        saveRoom()
        // setLight(updatedLight)
    }

    function changeArray(event: any, arrIndex: number, array: any[]){
        console.log(array)
        console.log(event.target.value)
        let updatedArr = array.map((val, i) => {
            console.log(val)
            if (i !== arrIndex) return val;
            return event.target.value;
        })
        console.log(updatedArr)
        return updatedArr
    }

    function populateLight(){
        let newArr = lightAmount.map((val, i) => {
            if (room["light"]["values"][i]) return {
                ...room["light"]["values"][i]
            }
            return val
        })
        return newArr
    }

    function populateArr(array: any[], origName: string){
        let newArr = array.map((val, i) => {
            if (room[origName]["values"][i]) return room[origName]["values"][i]
            return val
        })
        return newArr
    }

    function saveRoom(){
        let roomList = house.rooms
        console.log(roomList)
        let newList = roomList.map((list, i) => {
            if (i !== house.currentRoom) return list;
            return{
                ...list, 
                rgb: {...list["rgb"], values: rgbAmount},
                light: {...list["light"], values: workaround},
                heat: {...list["heat"], values: heatAmount},
                cooling: {...list["cooling"], values: coolAmount},
                sun: {...list["sun"], values: sunAmount},
            }
        })

        return new Promise((resolve, reject) => {
            dispatch(addRooms(newList))
            resolve(true)
        })
    }

    function HandleRouting(direction: string){
        saveRoom()
        switch (direction.toLowerCase()) {
            case "romtilbake":
                dispatch(changeCurrentRoom(0))
                Callback("/hInfo")
                break;
            case "neste":
                if(house.el_install && room.elInstall.needAmount > room.elInstall.totalAmount) return alert("Du trenger å legge til flere stikker før du kan gå videre")
                let increaseRoom = house.currentRoom + 1
                dispatch(changeCurrentRoom(increaseRoom))
                house.el_install ? Callback(`/room/${increaseRoom}/elInstall`) : Callback("/room/" + increaseRoom)
                break;
            case "tilbake":
                let decreaseRoom = house.currentRoom - 1;
                dispatch(changeCurrentRoom(decreaseRoom))
                house.el_install ? Callback(`/room/${decreaseRoom}/elInstall`) : Callback("/room/" + decreaseRoom)
            break;
            case "extra":
                if(house.el_install && room.elInstall.needAmount > room.elInstall.totalAmount) return alert("Du trenger å legge til flere stikker før du kan gå videre")
                Callback("/extra");
                break;
        
            default:
                console.log("Not finished yet")
                break;
        }
    }
    console.log(workaround)
    return(
        <div>
            <div>
                <img src={logo} />
            </div>
            <div className="mainDiv">
                <h3>{`${room["Navn"]} - Etasje ${room["Etasje"]}`}</h3>
                <h3>RGB</h3>
                <ul>
                    {rgbAmount.map((v, i) => (
                        <li><input 
                            key={`rgb_room_${house.currentRoom}_rgb${i}`} 
                            type="text" placeholder="Navn paa RGB" 
                            defaultValue={rgbAmount[i]} 
                            onChange={(event) => {rgbAmount = changeArray(event, i, rgbAmount); saveRoom()}} /></li>
                    ))}
                </ul>
                <hr />
                <h3>Lyssoner</h3>
                <ul>
                    {workaround.map((v, i) => (
                        <li>
                            <input 
                                key={`light_room_${house.currentRoom}_light${i}_name`} 
                                type="text" placeholder="Navn paa lys sone" 
                                value={workaround[i]["navn"]} 
                                onChange={(event) => {changeLight(event, i, "navn")}} 
                            /> 
                            <input 
                                key={`light_room_${house.currentRoom}_light${i}_elem`} 
                                type="number" 
                                placeholder="Antall elementer i lyssone" 
                                value={v.elements} 
                                onChange={(event) => changeLight(event,i,"amount")} />
                            
                            <div onChange={(event) => changeLight(event, i, "type")}>
                                <input  
                                    type="radio" 
                                    value="dali"
                                    id={`dali${i}`} 
                                    name={`typeCheck${i}`} 
                                    checked={v["type"]["dali"]}
                                />
                                    <label htmlFor={`dali${i}`}>Dali</label>                            
                                <input 
                                    type="radio" 
                                    id={`dim${i}`} 
                                    value="dim"
                                    name={`typeCheck${i}`} 
                                    checked={v["type"]["dim"]} 
                                />
                                    <label htmlFor={`dim${i}`}>Dim</label>                              
                                <input 
                                    type="radio" 
                                    id={`rele${i}`}
                                    value="rele"
                                    name={`typeCheck${i}`} 
                                    checked={v["type"]["rele"]} 
                                />
                                    <label htmlFor={`rele${i}`}>Rele</label>
                            </div>                    
                        </li>
                    ))}
                </ul>
                <hr />
                <h3>Varmesoner</h3>
                <ul>
                    {heatAmount.map((v, i) => (
                        <li>
                            <input 
                                key={`heat_room_${house.currentRoom}_heat${i}_`} 
                                type="text" 
                                placeholder="Navn paa varmesone" 
                                value={v} 
                                onChange={(event) => {heatAmount = changeArray(event, i, heatAmount); saveRoom()}} />
                        </li>
                    ))}
                </ul>
                <hr />
                <h3>Kjoling</h3>
                <ul>
                    {coolAmount.map((v, i) => (
                        <li>
                            <input 
                                type="text"
                                placeholder="Navn paa kjoling" 
                                value={v === "" ? '' : v} 
                                onChange={(event) => {coolAmount = changeArray(event, i, coolAmount); saveRoom()}} />
                        </li>
                    ))}
                </ul>
                <hr />
                <h3>Solavskjerming</h3>
                <ul>
                    {sunAmount.map((v,i) => (
                        <li>
                            <input 
                                type="text" 
                                placeholder="Navn paa solavskjerming" 
                                value={v} 
                                onChange={(event) => {sunAmount = changeArray(event, i, sunAmount); saveRoom()}} />
                        </li>
                    ))}
                </ul>
                <button className="btnTilbake" style={{visibility: house.currentRoom === (0) ? "hidden" : "visible"}} onClick={() => HandleRouting("tilbake")}>Forrige rom</button> 
                <button className="btnContinue" style={{visibility: house.currentRoom === (house.rooms.length - 1) ? "hidden" : "visible"}} onClick={() => HandleRouting("neste")}>Neste Rom</button><br />
                <button className="btnTilbake" onClick={() => HandleRouting("romtilbake")}>Tilbake hus informasjon</button>
                <button className="btnSave" style={{visibility: house.currentRoom === (house.rooms.length - 1) ? "visible" : "hidden"}} onClick={() => HandleRouting("extra")}>Til ekstra funksjoner</button>
            
            </div>
        </div>
    )
}